import React from 'react';
import { PropTypes } from 'prop-types';
import { get, startCase } from 'lodash';
import formatDate from 'common/utils/Dates/formatDate';
import TimelineEventDetails from 'common/Workqueue/TimelineEventDetails';
import BaseTimelineEvent from 'common/Workqueue/BaseTimelineEvent';

const isValidUUID = (value) => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);

const isValidDate = (value) => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/.test(value);

const formatEventChanges = (eventChanges, additionalData) => {
  const displayableFields = ['assigned_to', 'review_reason'];
  const formattedAdditionalData = Object.entries(additionalData)
    .filter(([dataKey]) => displayableFields.includes(dataKey) && dataKey !== 'assigned_to')
    .map(([dataKey, dataValue]) => ({ label: startCase(dataKey), value: dataValue }));

  const assigneeChange = eventChanges.find((change) => change.field_name === 'assignee_id');
  let assignedToData = [];
  if (assigneeChange && assigneeChange.to === null) {
    assignedToData = [{ label: 'Assigned To', value: 'Unassigned' }];
  } else if (additionalData.assigned_to) {
    assignedToData = [{ label: 'Assigned To', value: additionalData.assigned_to }];
  }

  const formattedChanges = eventChanges
    .filter((change) => !displayableFields.includes(change.field_name) && change.field_name !== 'assignee_id')
    .map((change) => {
      const changedTo = change.to;
      if (isValidUUID(changedTo)) {
        return null;
      }
      if (isValidDate(changedTo)) {
        return { label: startCase(change.field_name), value: formatDate(changedTo) };
      }
      const label = change.field_name === 'in_review_note' ? 'Notes' : startCase(change.field_name);
      return { label, value: changedTo === null ? 'Not Specified' : changedTo.toString() };
    });

  return [...formattedChanges, ...assignedToData, ...formattedAdditionalData].filter(Boolean);
};

const ServiceAuthorizationEditEvent = ({ timelineEvent }) => {
  const additionalData = get(timelineEvent, 'additional_data');

  const eventChanges = get(timelineEvent, 'changes', []);
  const employeeName = get(additionalData, 'employee_name');

  const icon = 'IconPencil';
  const message = `Edited by ${employeeName}`;
  const date = formatDate(timelineEvent.timestamp);
  const eventDetailItems = formatEventChanges(eventChanges, additionalData);
  const eventDetails = eventDetailItems ? (
    <TimelineEventDetails eventItems={eventDetailItems} eventDate={date} />
  ) : null;

  const formattedTimelineEvent = {
    icon,
    message,
    date,
    eventDetails,
  };

  return (
    <BaseTimelineEvent {...formattedTimelineEvent} />
  );
};

ServiceAuthorizationEditEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default ServiceAuthorizationEditEvent;
